// extracted by mini-css-extract-plugin
export default {"colorBox":"styles__colorBox___mTs7r","icon":"styles__icon___Gtr3j"};